import { http } from 'vue'

export default {
  // create reference at the API server
  postReference (context, params = {}) {
    return http.post('references', params.data)
  },
  // edit reference at the API server
  putReference (context, params = {}) {
    return http.put('references/' + params.id, params.data)
  },
  // delete reference at the API server
  deleteReference (context, params = {}) {
    return http.delete('references/' + params.id)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/references/actions.js